import { Link } from "gatsby"
import FormattedDateWithDefaults from "./FormattedDateWithDefaults"

import { event } from "@templates/press.module.css"

const PressReleaseLink = ({ post, readMoreText }) => {
  const offsite = /^(https?:)?\/\//.test(post.slug)
  const url = offsite ? post.slug : `/press/press-releases/${post.slug}`
  return (
    <div className={event} key={post.id}>
      <h4>
        <Link to={url}>{post.title}</Link>
      </h4>
      <p>
        <FormattedDateWithDefaults value={post.date} />
      </p>
      <Link to={url}>{readMoreText}</Link>
    </div>
  )
}

export default PressReleaseLink
